// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"645a16ec","466":"72539a9e","486":"1b476a18","846":"ea5f1458"}[chunkId] + ".css";
};